import React, { useEffect, useRef } from 'react';
import { translate } from '../../Services/translation';

const ConfiguratorQuantityInput = ({ quantity = 0, onChangeQuantity }) => {
  const addButtonRef = useRef(null);
  const increaseButtonRef = useRef(null);
  // The add button and the quantity control replace each other, so focus is handed over when one unmounts.
  const pendingFocusRef = useRef(null);
  const isEmpty = quantity === 0;

  useEffect(() => {
    if (!pendingFocusRef.current) return;
    pendingFocusRef.current.current?.focus();
    pendingFocusRef.current = null;
  }, [isEmpty]);

  const changeQuantity = (newQuantity) => {
    if (isEmpty && newQuantity > 0) {
      pendingFocusRef.current = increaseButtonRef;
    } else if (!isEmpty && newQuantity === 0) {
      pendingFocusRef.current = addButtonRef;
    }
    onChangeQuantity(newQuantity);
  };

  if (isEmpty) {
    return (
        <button
            type="button"
            ref={addButtonRef}
            onClick={() => changeQuantity(1)}
            className="configurator__quantity-add-btn"
        >
            {translate('brenderup.configurator.button.add')}
        </button>
    );
  }

  return (
    <div className="configurator__quantity-control">
        <button
        type="button"
        onClick={() => changeQuantity(quantity - 1)}
        >
            -
        </button>
        <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={quantity}
            onChange={(e) => {
            const val = parseInt(e.target.value, 10);
            if (isNaN(val) || val < 0) {
                changeQuantity(0);
            } else {
                changeQuantity(val);
            }
            }}
        />
        <button
            type="button"
            ref={increaseButtonRef}
            onClick={() => changeQuantity(quantity + 1)}
        >
            +
        </button>
    </div>
  );
};

export default ConfiguratorQuantityInput;
